import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { SAVED_FILTERS_QUERY_KEYS } from 'app/modules/filters/queries/keys';
import { Filter, FilterContext, SavedFilter } from 'app/modules/filters/models';
import { post } from 'app/shared/utils/fetchr';
import { sendErrorToast, sendSuccessToast } from 'app/shared/toasts/actions';

interface CreateSavedFilterPayload {
  title: string;
  description?: string;
  filter_context: FilterContext;
  filters: Filter[];
  team_ids?: number[];
}

export const useCreateSavedFilter = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateSavedFilterPayload) =>
      post<SavedFilter>('/v1/saved-filters', payload),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: SAVED_FILTERS_QUERY_KEYS.list(data.filter_context),
      });
      dispatch(sendSuccessToast('Successfully saved filter.'));
    },
    onError: () =>
      dispatch(sendErrorToast('Failed to save filter. Please try again.')),
  });
};
